import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, renderSlot as _renderSlot, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withModifiers as _withModifiers, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "data-status-grid" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-search pe-1" }, null, -1)
const _hoisted_4 = {
  key: 0,
  class: "filter-description"
}
const _hoisted_5 = {
  class: "btn-group",
  role: "group"
}
const _hoisted_6 = { class: "form-check d-inline-block" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "cbAddCol",
  class: "form-check-label"
}, "Display with the latest explanation/justification for Status change", -1)
const _hoisted_8 = {
  class: "btn-group ms-auto",
  style: {},
  role: "group"
}
const _hoisted_9 = ["href"]
const _hoisted_10 = ["href"]
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["href"]
const _hoisted_14 = { key: 1 }
const _hoisted_15 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_information_modal = _resolveComponent("information-modal")!
  const _component_errors_warnings_update = _resolveComponent("errors-warnings-update")!
  const _component_b_filter_modal = _resolveComponent("b-filter-modal")!
  const _component_drop_down = _resolveComponent("drop-down")!
  const _component_b_table_header = _resolveComponent("b-table-header")!
  const _component_b_table = _resolveComponent("b-table")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_loading_spinner, { "show-loading": _ctx.showLoading }, null, 8, ["show-loading"]),
    _createVNode(_component_information_modal, {
      title: _ctx.selectedErrorCode,
      "show-modal": _ctx.showErrorDescriptionModal,
      onDismiss: _ctx.handleErrorDescriptionModalDismiss
    }, {
      body: _withCtx(() => [
        _createElementVNode("div", { innerHTML: _ctx.selectedErrorBody }, null, 8, _hoisted_2)
      ]),
      _: 1
    }, 8, ["title", "show-modal", "onDismiss"]),
    _createVNode(_component_information_modal, {
      title: _ctx.updateModalTitle,
      "show-modal": _ctx.showUpdateModal,
      "show-footer": true,
      "modal-style": 'max-width:950px',
      onDismiss: _ctx.handleUpdateModalDismiss
    }, {
      body: _withCtx(({ onDismiss }) => [
        _createVNode(_component_errors_warnings_update, {
          item: _ctx.selectedItem,
          url: `${_ctx.url}/update/`,
          dataset: _ctx.dataset,
          onDismiss: onDismiss
        }, null, 8, ["item", "url", "dataset", "onDismiss"])
      ]),
      _: 1
    }, 8, ["title", "show-modal", "onDismiss"]),
    _createVNode(_component_b_filter_modal, {
      isShowFilterEditor: _ctx.isShowFilterEditor,
      filterOptions: _ctx.filterOptions,
      filterableFields: _ctx.filterableFields,
      onFilterChanged: _ctx.applyFilters,
      onDismissModal: _ctx.handleDismiss
    }, null, 8, ["isShowFilterEditor", "filterOptions", "filterableFields", "onFilterChanged", "onDismissModal"]),
    _createVNode(_component_b_table_header, {
      value: _ctx.options,
      onOptionChange: _ctx.handleOptionChange,
      "header-slot-class": "b-header-slot w-100 position-relative",
      filters: _ctx.filterOptions.filters,
      "current-item-count": _ctx.numberOfReturnedItems
    }, {
      default: _withCtx(() => [
        _createElementVNode("button", {
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showFilterEditor($event))),
          class: "btn btn-primary"
        }, [
          _hoisted_3,
          _createTextVNode(" Filter ")
        ]),
        _renderSlot(_ctx.$slots, "header.toolbar"),
        (_ctx.hasAppliedFilters)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.filtersDescription), 1))
          : _createCommentVNode("", true),
        (_ctx.hasAppliedFilters)
          ? _withDirectives((_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "btn-close",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.resetFilters()))
            }, null, 512)), [
              [_directive_tooltip, 'Remove all currently applied filters.']
            ])
          : _createCommentVNode("", true)
      ]),
      pagingStart: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_drop_down, {
            label: "Export Data",
            "item-count": 2,
            "is-primary-button": true
          }, {
            item1: _withCtx(({ item }) => [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:void",
                onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (_ctx.exportData('csv')), ["prevent"]))
              }, "Download as .csv")
            ]),
            item2: _withCtx(({ item }) => [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: "javascript:void",
                onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.exportData('xlsx')), ["prevent"]))
              }, "Download as .xlsx")
            ]),
            _: 1
          })
        ])
      ]),
      headerTopBar: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createElementVNode("input", {
            id: "cbAddCol",
            type: "checkbox",
            class: "form-check-input",
            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.showAdditionalColumns) = $event))
          }, null, 512), [
            [_vModelCheckbox, _ctx.showAdditionalColumns]
          ]),
          _hoisted_7
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_drop_down, {
            label: "Error/Warning Details",
            "item-count": 2,
            "is-primary-button": false
          }, {
            item1: _withCtx(({}) => [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: `${_ctx.store.errorDescriptionsDownloadUrl}csv`
              }, "Download as .csv", 8, _hoisted_9)
            ]),
            item2: _withCtx(({}) => [
              _createElementVNode("a", {
                class: "dropdown-item",
                href: `${_ctx.store.errorDescriptionsDownloadUrl}xlsx`
              }, "Download as .xlsx", 8, _hoisted_10)
            ]),
            _: 1
          })
        ])
      ]),
      _: 3
    }, 8, ["value", "onOptionChange", "filters", "current-item-count"]),
    _createVNode(_component_b_table, {
      items: _ctx.dataItems,
      columns: _ctx.columns,
      caption: 'List of errors and warnings',
      value: _ctx.options,
      onOptionChange: _ctx.handleOptionChange
    }, {
      "cell.status": _withCtx(({ item, column }) => [
        (_ctx.isStatusLinkEnabled(item))
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
              onClick: _withModifiers(($event: any) => (_ctx.handleStatusClick(item)), ["prevent"])
            }, _toDisplayString(item.status), 9, _hoisted_11))
          : (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(item.status), 1))
      ]),
      "cell.incidentNumber": _withCtx(({ item }) => [
        (_ctx.enableLinkToEditor)
          ? (_openBlock(), _createElementBlock("a", {
              key: 0,
              class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
              href: _ctx.getEditorPageName(_ctx.getValueFromSource(item, 'incidentNumber'), _ctx.getValueFromSource(item, 'ori'))
            }, _toDisplayString(item["incidentNumber"]), 9, _hoisted_13))
          : _createCommentVNode("", true),
        (!_ctx.enableLinkToEditor)
          ? (_openBlock(), _createElementBlock("span", _hoisted_14, _toDisplayString(item["incidentNumber"]), 1))
          : _createCommentVNode("", true)
      ]),
      "cell.errorCode": _withCtx(({ item }) => [
        _createElementVNode("button", {
          type: "button",
          class: "btn btn-link kendo-stop-hiding-my-links ms-0 ps-0 text-start",
          onClick: _withModifiers(($event: any) => (_ctx.handleErrorCodeClick(item)), ["prevent"])
        }, _toDisplayString(item["errorCode"]), 9, _hoisted_15)
      ]),
      _: 1
    }, 8, ["items", "columns", "value", "onOptionChange"]),
    _createVNode(_component_b_table_header, {
      value: _ctx.options,
      onOptionChange: _ctx.handleOptionChange,
      "header-slot-class": "b-header-slot w-100",
      filters: _ctx.filterOptions.filters,
      "current-item-count": _ctx.numberOfReturnedItems
    }, null, 8, ["value", "onOptionChange", "filters", "current-item-count"])
  ]))
}